import { BaseDynamicFormElement } from './dynamic-form-base.class';
import { BaseDynamicFormElementInterface } from './base-dynamic-form-element.interface';

export class RadioElement extends BaseDynamicFormElement<string> {
  constructor(config: Partial<BaseDynamicFormElementInterface<string>>) {
    super({
      ...config,
      controlType: 'radio',
    });
  }
}
